import { makeStyles } from "@material-ui/core/styles";

export const useStyle = makeStyles({
  newsContainer: {
    marginTop: "70px",
  },
  heading: {
    fontFamily: "Poppins",
    fontSize: "50px",
    color: "#1b1825",
    width: "70%",
    margin: "20px auto",
  },
  container: {
    padding: "3% 80px",
    width: "100%",
  },
});
